import { alpha } from "@mui/material/styles";
import { mascaraStatusEmpreendedor } from "./constants";
import { getStatusPaletteKey } from "./statusPalette";

export function sxBlocoComentario(status) {
  const paletteKey = getStatusPaletteKey(mascaraStatusEmpreendedor(status));
  const borderToken = paletteKey === "grey" ? "grey.500" : `${paletteKey}.main`;
  return {
    mt: 1,
    p: 1,
    color: "text.primary",
    borderRadius: 1,
    borderLeft: "4px solid",
    borderLeftColor: borderToken,
    bgcolor: (theme) => {
      const fill =
        paletteKey === "grey" || !theme.palette[paletteKey]?.main
          ? theme.palette.grey[500]
          : theme.palette[paletteKey].main;
      return alpha(fill, 0.12);
    },
  };
}
